import { ElementRef, HostListener, Injectable, NgZone, QueryList, Renderer2 } from "@angular/core";
import { QueovalDik } from "../models";
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class qDragAndDropService {

  public dndConfig: qDragAndDropConfig;
  //**** Drag&Drop Value ****\\
  private dragEl: any;
  private dragX: any;
  private dragY: any;
  private dragOffsetX: any;
  private dragOffsetY: any;
  private startX: any;
  private startY: any;
  private isDrag: boolean = false;

  private srcColId: any;
  private srcCardId: any;
  private destColId: any;
  private destCardId: any;
  private lastColId: any;
  private lastCardId: any;
  private currentColId: any;
  private currentCardId: any;

  private overCard: boolean = false;

  private cardPlaceHolderTop: boolean = false;
  private cardPlaceHolderBot: boolean = false;

  private draggedElement: any;
  private targetColumnElement: any;

  private listListner: Array<any> = new Array<any>();

  private callbackDrop: qDragAndDropCallback = new qDragAndDropCallback();
  public updateCallbackDrop$ = Observable.create((observer: any) => {
    observer.next(this.callbackDrop);
  });
  public callbackDrop$ = new Subject();



  private callbackClick: qDragAndDropCallback = new qDragAndDropCallback();
  public updateCallbackClick$ = Observable.create((observer: any) => {
    observer.next(this.callbackClick);
  });
  public callbackClick$ = new Subject();


  private placeHolder: any;



  constructor(
    protected zone: NgZone,
    protected renderer: Renderer2) {
  }

  public initDnD(el: any) {
    if (this.dndConfig.autoBindingEvent) {

      document.addEventListener('mouseup', this.onMouseUpWindows.bind(this));


      this.listListner.forEach((listner: any) => { listner(); });
      this.listListner = new Array<any>();

      if (this.dndConfig.wrapperElement != null) {
        this.listListner.push(this.renderer.listen(this.dndConfig.wrapperElement.nativeElement, 'mousemove', (event: any) => { this.onMouseMoveWrapper(event) }));
      }
      let colCount: number = 0;
      let cardCount: number = 0;
      if (this.dndConfig.columnElement != null) {
        colCount = 0;
        this.dndConfig.columnElement.forEach((colEl: ElementRef) => {
          this.bindColumnEvent(colEl, colCount);
          colCount++;
        });
      }

      if (this.dndConfig.cardElement != null) {
        let colCardCount: Array<number> = new Array<number>();
        this.dndConfig.colObj.forEach((col: any) => {
          colCardCount.push(col[this.dndConfig.cardObjName].length);
        });

        cardCount = 0;
        colCount = 0;
        this.dndConfig.cardElement.forEach((cardEl: ElementRef) => {
          if (cardCount == colCardCount[0]) {
            cardCount = 0;
            do {
              colCount++;
              colCardCount.splice(0, 1);
            } while (colCardCount.length > 0 && colCardCount[0] == 0)
          }

          if (colCardCount[0] > 0) {
            this.bindCardEvent(cardEl, colCount, cardCount);
            cardCount++;
          }
        });
      }
    }
  }


  //**** Windows Event ****\\
  public onMouseUpWindows(event: any) {
    this.zone.runOutsideAngular(() => {
      if (this.dragEl != undefined && this.isDrag) {
        this.dragEl.remove()
        this.dragEl = undefined;
        let srcCard = this.dndConfig.colObj[this.srcColId][this.dndConfig.cardObjName][this.srcCardId];
        switch (this.dndConfig.mode) {
          case qDragAndDropMode.cardPosition:
            if (!(this.srcColId == this.destColId && this.srcCardId == this.destCardId)) {
              if (this.destCardId < this.srcCardId) {
                this.dndConfig.colObj[this.srcColId][this.dndConfig.cardObjName].splice(this.srcCardId, 1);
                this.dndConfig.colObj[this.destColId][this.dndConfig.cardObjName].splice(this.destCardId, 0, srcCard);
              } else {
                this.dndConfig.colObj[this.destColId][this.dndConfig.cardObjName].splice(this.destCardId, 0, srcCard);
                this.dndConfig.colObj[this.srcColId][this.dndConfig.cardObjName].splice(this.srcCardId, 1);
              }
            }
            break;

          case qDragAndDropMode.columnOnly:
          default:
            if (this.srcColId != this.destColId) {
              this.dndConfig.colObj[this.srcColId][this.dndConfig.cardObjName].splice(this.srcCardId, 1);
              this.dndConfig.colObj[this.destColId][this.dndConfig.cardObjName].splice(this.destCardId, 0, srcCard);
            }
            else {
              this.destCardId = this.srcCardId;
            }
            break;
        }
        this.draggedElement.classList.remove('dragging');
        if (this.dndConfig.wrapperElement) {
          this.renderer.removeClass(this.dndConfig.wrapperElement.nativeElement, 'dragging');
        }
        if (this.targetColumnElement) {
          this.targetColumnElement.classList.remove('overingColumn');
        }

        this.callbackDrop = {
          ident: srcCard.Ident,
          oldColId: this.srcColId,
          oldCardId: this.srcCardId,
          newColId: this.destColId,
          newCardId: this.destCardId
        }
        this.updateCallbackDrop$.subscribe(this.callbackDrop$);

        this.placeHolder.remove();
        this.placeHolder = undefined;
        this.draggedElement = undefined;
        this.isDrag = false;
      }
    });
  }



  //**** Wrapper Event ****\\
  public onMouseMoveWrapper(event: any) {
    this.zone.runOutsideAngular(() => {
      event.preventDefault();

      this.dragX = event.pageX;
      this.dragY = event.pageY;
      let moveScale = 10;

      if (this.draggedElement) {
        if (!this.isDrag && ((Math.abs(this.dragX - this.startX) > moveScale || Math.abs(this.dragY - this.startY) > moveScale))) {
          this.isDrag = true;

          this.dragOffsetX = this.draggedElement.offsetWidth / 2;
          this.dragOffsetY = this.draggedElement.offsetHeight / 2;
          this.draggedElement.classList.add('dragging');

          if (this.dndConfig.wrapperElement) {
            this.renderer.addClass(this.dndConfig.wrapperElement.nativeElement, 'dragging');
          }

          this.dragElement();
          this.moveDragEl(event);

        }
      }
      if (this.dragEl != undefined) {
        this.moveDragEl(event);
      }
    });
  }

  //**** Column Event ****\\
  public onMouseMoveColumn(event: any, colId: number) {
    this.zone.runOutsideAngular(() => {
      event.preventDefault();
      if (!this.overCard && this.dragEl != undefined) {

        this.currentColId = colId;
        if (this.currentColId != this.lastColId) {
          this.lastCardId = undefined;
          this.lastColId = this.currentColId;

          let colLength = this.dndConfig.colObj[colId][this.dndConfig.cardObjName].length;
          this.destColId = this.currentColId;
          this.destCardId = colLength;
          this.pushPlaceHoler(event, 'column');
        }

      }
    });
  }
  public onMouseEnterColumn(event: any, colId: number) {
    event.preventDefault();
    if (this.dragEl != undefined && this.srcColId != colId) {
      this.targetColumnElement = event.currentTarget;
      this.targetColumnElement.classList.add('overingColumn');
    }
  }
  public onMouseLeaveColumn(event: any, colId: number) {
    event.preventDefault();
    if (this.dragEl != undefined && this.srcColId != colId) {
      this.targetColumnElement.classList.remove('overingColumn');
    }
  }

  //**** Event Card ****\\
  public onMouseDownCard(event: any, colId: number, cardId: number) {
    this.srcColId = this.srcCardId = this.destColId = this.destCardId = this.lastColId = this.lastCardId = this.currentColId = this.currentCardId = this.dragEl = undefined;

    this.draggedElement = event.currentTarget;

    this.srcColId = this.destColId = colId;
    this.srcCardId = this.destCardId = cardId;

    this.startX = event.clientX;
    this.startY = event.clientY;



  }
  public onMouseUpCard(event: any) {
    if (!this.isDrag) {
      this.isDrag = false;
      this.draggedElement = undefined;


      this.callbackClick = {
        ident: this.dndConfig.colObj[this.srcColId][this.dndConfig.cardObjName][this.srcCardId].Ident,
        oldColId: this.srcColId,
        oldCardId: this.srcCardId,
        newColId: this.destColId,
        newCardId: this.destCardId
      }
      this.updateCallbackClick$.subscribe(this.callbackClick$);
    }

  }
  private dragElement() {
    // Creation de l'element drag
    this.dragEl = this.draggedElement.cloneNode(true);
    this.dragEl.className = 'pipeCard';
    this.dragEl.style.position = 'absolute';
    this.dragEl.style.opacity = '0.9';
    this.dragEl.style.pointerEvents = 'none';
    this.dragEl.style.zIndex = '20';
    this.dragEl.style.width = `${this.draggedElement.offsetWidth}px`;
    document.body.appendChild(this.dragEl);

    // Creation du placeholder
    this.placeHolder = this.draggedElement.cloneNode(true);
    this.placeHolder.textContent = '';
    this.placeHolder.classList.add("dragging");
    this.placeHolder.id = '';
  }

  public onMouseEnterCard(event: any) {
    event.preventDefault();
    if (this.dragEl != undefined) {
      this.overCard = true;
    }
  }
  public onMouseLeaveCard(event: any) {
    event.preventDefault();
    if (this.dragEl != undefined) {
      this.cardPlaceHolderTop = this.cardPlaceHolderBot = this.overCard = false;
    }
  }
  public onMouseMoveCard(event: any, colId: number, cardId: number) {
    event.preventDefault();
    if (this.dragEl != undefined) {
      this.zone.runOutsideAngular(() => {

        this.currentColId = colId;
        this.currentCardId = cardId;

        // Recuperation de la position sur la page de la carte survolé
        const cardPos = event.currentTarget.getBoundingClientRect();

        // Si la carte survolé est la source, on ne fait rien.
        if (this.srcColId == this.currentColId && this.srcCardId == this.currentCardId && (this.currentCardId != this.lastCardId || this.currentColId != this.lastColId)) {
          this.lastCardId = this.currentCardId;
          this.lastColId = this.currentColId;
          this.destColId = this.srcColId;
          this.destCardId = this.srcCardId;
          // this.clearPlaceHolder();
          this.placeHolder.remove();
        }

        // Si la carte survolé n'a pas la classe "dragging" (donc qui n'est pas un placeholder ou la carte source)
        if (!event.currentTarget.classList.contains("dragging")) {
          this.lastCardId = this.currentCardId;
          this.lastColId = this.currentColId;
          let midCardY = cardPos.y + (cardPos.height / 2);
          // Check si la souris est dans la moitié haute de la carte survolé
          if (this.dragY < midCardY) {
            if (!this.cardPlaceHolderTop) {
              this.cardPlaceHolderTop = true;
              this.cardPlaceHolderBot = false;
              if (this.currentColId == this.srcColId) {
                // Check si la carte source est au dessus de la carte survolé
                if (this.currentCardId - 1 == this.srcCardId) {
                  this.destColId = this.srcColId;
                  this.destCardId = this.srcCardId;
                } else {
                  // Place la destination au dessus la carte survolé
                  this.destColId = this.currentColId;
                  this.destCardId = this.currentCardId;
                }
              } else {
                // Place la destination au dessus la carte survolé
                this.destColId = this.currentColId;
                this.destCardId = this.currentCardId;
              }
              this.pushPlaceHoler(event);
            }
          } else {
            if (!this.cardPlaceHolderBot) {
              this.cardPlaceHolderTop = false;
              this.cardPlaceHolderBot = true;
              if (this.currentColId == this.srcColId) {
                // Check si la carte source est en desous de la carte survolé
                if (this.currentCardId + 1 == this.srcCardId) {
                  this.destColId = this.srcColId;
                  this.destCardId = this.srcCardId;
                } else {
                  // Place la destination en dessous la carte survolé
                  this.destColId = this.currentColId;
                  this.destCardId = this.currentCardId + 1;
                }
              } else {
                // Place la destination en dessous la carte survolé
                this.destColId = this.currentColId;
                this.destCardId = this.currentCardId + 1;
              }
              this.pushPlaceHoler(event);
            }
          }
        }
      });
    }
  }


  //**** Private function ****\\
  private bindColumnEvent(col: ElementRef, colId: number) {
    this.listListner.push(this.renderer.listen(col.nativeElement, 'mousemove', (event: any) => { this.onMouseMoveColumn(event, colId) }));

    if (this.dndConfig.mode == qDragAndDropMode.columnOnly) {
      this.listListner.push(this.renderer.listen(col.nativeElement, 'mouseenter', (event: any) => { this.onMouseEnterColumn(event, colId) }));
      this.listListner.push(this.renderer.listen(col.nativeElement, 'mouseleave', (event: any) => { this.onMouseLeaveColumn(event, colId) }));
    }
  }
  private bindCardEvent(col: ElementRef, colId: number, cardId: number) {
    this.listListner.push(this.renderer.listen(col.nativeElement, 'mousedown', (event: any) => { this.onMouseDownCard(event, colId, cardId) }));
    this.listListner.push(this.renderer.listen(col.nativeElement, 'mouseup', (event: any) => { this.onMouseUpCard(event) }));

    if (this.dndConfig.mode == qDragAndDropMode.cardPosition) {
      this.listListner.push(this.renderer.listen(col.nativeElement, 'mouseenter', (event: any) => { this.onMouseEnterCard(event) }));
      this.listListner.push(this.renderer.listen(col.nativeElement, 'mouseleave', (event: any) => { this.onMouseLeaveCard(event) }));
      this.listListner.push(this.renderer.listen(col.nativeElement, 'mousemove', (event: any) => { this.onMouseMoveCard(event, colId, cardId) }));
    }
  }
  private moveDragEl(event: any) {
    event = event || window.event;
    /*    this.dragX = event.pageX;*/
    /*    this.dragY = event.pageY;*/
    this.dragEl.style.left = `${this.dragX - this.dragOffsetX}px`;
    this.dragEl.style.top = `${this.dragY - this.dragOffsetY}px`;
    let deg = this.clamp((this.dragX - this.startX) / 10, -10, 10);
    this.dragEl.style.transform = `rotate(${deg}deg)`;

    if (this.dndConfig.wrapperElement) {
      let sideScrollScale = 150;


      let wrapperLeft = this.dndConfig.wrapperElement.nativeElement.getBoundingClientRect().left;
      let wrapperRight = wrapperLeft + this.dndConfig.wrapperElement.nativeElement.clientWidth;

      if (this.dragX > wrapperRight - sideScrollScale) {
        this.dndConfig.wrapperElement.nativeElement.scrollTo({ left: (this.dndConfig.wrapperElement.nativeElement.scrollLeft + 25) });
      }

      if (this.dragX < wrapperLeft + sideScrollScale) {
        this.dndConfig.wrapperElement.nativeElement.scrollTo({ left: (this.dndConfig.wrapperElement.nativeElement.scrollLeft - 25) });
      }

    }
  }

  private pushPlaceHoler(event: any, type: string = 'card') {
    if (this.dndConfig.mode != qDragAndDropMode.columnOnly) {
      if (this.placeHolder != undefined) {
        this.placeHolder.remove();
      }
      // Si la destination est la carte source, on ne ajoute pas de placeholder
      if (!(this.destColId == this.srcColId && this.destCardId == this.srcCardId)) {

        const element = event.currentTarget;
        if (type == 'card') {
          // Placement du placeholder en fonction du positionnement de le souris sur l'element survolé
          if (this.cardPlaceHolderTop) {
            element.parentElement.insertBefore(this.placeHolder, element);
          } else {
            element.parentElement.insertBefore(this.placeHolder, element.nextSibling);
          }
        } else if (type == 'column') {
          element.appendChild(this.placeHolder);
        }
      }
    }
  }

  private clamp(value: any, min: any, max: any) {
    return Math.min(Math.max(value, min), max);
  };

  public UpdateColModel(colModel: Array<any>) {
    this.dndConfig.colObj = colModel;
  };
}



export enum qDragAndDropMode {
  columnOnly,
  cardPosition
}
export class qDragAndDropConfig {

  colObj: Array<any>;
  cardObjName: string;
  mode?: qDragAndDropMode;

  autoBindingEvent?: boolean;
  wrapperElement?: ElementRef | null;
  columnElement?: QueryList<ElementRef> | null;
  cardElement?: QueryList<ElementRef> | null

  constructor() {
    this.mode = qDragAndDropMode.columnOnly;
    this.autoBindingEvent = false;
    this.wrapperElement = null;
    this.columnElement = null;
    this.cardElement = null;
  }

}
export class qDragAndDropCallback {
  ident: string;
  oldColId: any;
  oldCardId: any
  newColId: any;
  newCardId: any;
}
